import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useRejectedReviewQuery } from 'components/hooks/rejectedReviewQueries';

import ModalBox from 'components/application/ModalBox';
import ProfilePhotoDisplay from 'components/application/ProfilePhotoDisplay';

import { asFormattedDateTime } from 'components/helpers/dates';
import { personDisplayName } from 'components/helpers/users';

export default function RejectedReviewModal({ onClose, reviewId }) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'projectPersonnel.components.RejectedReviewModal',
  });

  const { t: i18nTProjects } = useTranslation('common', {
    keyPrefix: 'projects',
  });

  const {
    data: domainRejectedReview,
    isSuccess: isDomainRejectedReviewSuccess,
  } = useRejectedReviewQuery({ reviewId });

  if (!isDomainRejectedReviewSuccess) return null;

  const {
    data: {
      attributes: { rejectedAt, rejectionReason },
      relationships: {
        projectPersonnel: {
          data: { id: projectPersonnelId },
        },
        reviewedVersion: {
          data: { id: reviewedVersionId },
        },
      },
    },
    included,
  } = domainRejectedReview;

  const {
    attributes: { firstName, lastName },
    relationships: {
      profilePhoto: { data: profilePhotoData },
    },
  } =
    included.personnel[
      included.projectPersonnel[projectPersonnelId].relationships.personnel.data
        .id
    ];

  const profilePhoto =
    profilePhotoData && included.profilePhoto[profilePhotoData.id];

  const {
    attributes: { displayNumber: versionNumber },
  } = included.version[reviewedVersionId];

  return (
    <ModalBox isOpen={true} onClose={onClose}>
      <div className='tw-flex tw-items-center tw-border-b-1 tw-border-t-1 tw-border-solid tw-border-grey-100 tw-px-6 tw-py-3'>
        <div className='tw-mr-3'>
          <ProfilePhotoDisplay
            componentSize='md'
            photoUrl={profilePhoto?.links?.croppedUrl}
            profileInitials={`${firstName[0]}${lastName[0]}`}
          />
        </div>
        <div>
          <h2 className='tw-m-0 tw-font-inter tw-text-l tw-font-semibold tw-tracking-auto tw-text-grey-900'>
            {i18nT('title', {
              displayName: personDisplayName({
                attributes: { firstName, lastName },
              }),
              interpolation: { escapeValue: false },
            })}
          </h2>
          <p className='tw-m-0'>
            {i18nTProjects('versionNumberOnDateTime', {
              dateTime: asFormattedDateTime({ date: rejectedAt }),
              versionNumber,
            })}
          </p>
        </div>
      </div>
      <div className='popup__body'>
        <div className='popup__body-light'>
          <p className='tw-m-0 tw-p-0'>{rejectionReason}</p>
        </div>
      </div>
    </ModalBox>
  );
}

RejectedReviewModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  reviewId: PropTypes.string.isRequired,
};
